import React from "react";
import * as S from "./SetupFrame.styles";
import type { SetupFrameProps } from "./SetupFrame.types";

/** Generic three-column setup page: steps rail, work area and preview, with a top bar, heading and sticky footer. */
export const SetupFrame = ({
  topBar,
  banner,
  title,
  plan,
  steps,
  work,
  preview,
  footer,
  wideWork = false,
  "data-testid": testId = "setup-frame",
}: SetupFrameProps) => (
  <S.Root data-testid={testId}>
    {topBar && <S.TopBar data-testid={`${testId}-top-bar`}>{topBar}</S.TopBar>}
    {banner && <S.Banner data-testid={`${testId}-banner`}>{banner}</S.Banner>}
    {(title || plan) && (
      <S.Heading data-testid={`${testId}-heading`}>
        {title}
        {plan}
      </S.Heading>
    )}
    <S.Columns $wideWork={wideWork} data-testid={`${testId}-columns`}>
      <S.Steps data-testid={`${testId}-steps`}>{steps}</S.Steps>
      <S.Work data-testid={`${testId}-work`}>{work}</S.Work>
      {preview && <S.Preview data-testid={`${testId}-preview`}>{preview}</S.Preview>}
    </S.Columns>
    {footer && <S.Footer data-testid={`${testId}-footer`}>{footer}</S.Footer>}
  </S.Root>
);

export default SetupFrame;
